import { proxy } from 'valtio'

export type MatchTeam = 'home' | 'away'
export type MatchPossession = 'HOME' | 'AWAY'
export type MatchPeriod = '1H' | '2H' | 'HT' | 'FT'
export type MatchEventType =
  | 'CLOCK_UPDATE' | 'KICKOFF' | 'HALF_TIME' | 'SECOND_HALF_START' | 'FULL_TIME'
  | 'GOAL' | 'OWN_GOAL' | 'PENALTY_GOAL' | 'PENALTY_SHOOTOUT_GOAL' | 'GOAL_DISALLOWED'
  | 'YELLOW_CARD' | 'YELLOW_RED_CARD' | 'RED_CARD'
  | 'CORNER' | 'FREE_KICK' | 'PENALTY' | 'PENALTY_MISSED' | 'THROW_IN' | 'GOAL_KICK' | 'OFFSIDE'
  | 'SHOT_ON_TARGET' | 'SHOT_OFF_TARGET'
  | 'ASSIST' | 'SUBSTITUTION' | 'VAR_REVIEW' | 'VAR_DECISION' | 'INJURY'
  | 'BALL_POSITION' | 'STAT_UPDATE' | 'POSSESSION_UPDATE'

export interface MatchScore {
  home: number
  away: number
}

export interface MatchClock {
  minute: number
  second: number
  period: MatchPeriod
}

export interface BallPosition {
  x: number
  y: number
  possession: MatchPossession
}

export interface MatchStat {
  name: string
  home: number
  away: number
}

export interface MatchOddsOption {
  name: string
  pct: number
}

export interface MatchOddsMarket {
  market: string
  options: MatchOddsOption[]
}

export interface MatchEventEntry {
  type: MatchEventType
  timestamp: number
  team: MatchTeam | null
  playerName: string | null
  description: string | null
  clock: MatchClock | null
  score: MatchScore | null
}

export interface SoccerState {
  code: number
  name: string
}

interface MatchTrackingStateType {
  matchId: string
  homeName: string
  awayName: string
  score: MatchScore
  clock: MatchClock
  ballPosition: BallPosition | null
  stats: MatchStat[]
  odds: MatchOddsMarket[]
  recentEvents: MatchEventEntry[]
  connected: boolean
  activeTab: 'stats' | 'events'
  /** Timestamp set at hydration time — events older than this are historical and should not trigger pitch overlays */
  liveEventCursor: number
  statusCode: SoccerState | null
  /** False until a snapshot arrives — the match has no live data yet (upcoming). */
  hasData: boolean
}

const initialState: MatchTrackingStateType = {
  matchId: 'match-demo-001',
  homeName: '',
  awayName: '',
  score: { home: 0, away: 0 },
  clock: { minute: 0, second: 0, period: '1H' },
  ballPosition: null,
  stats: [],
  odds: [],
  recentEvents: [],
  connected: false,
  activeTab: 'stats',
  liveEventCursor: 0,
  statusCode: null,
  hasData: false,
}

export const MatchTrackingState = proxy<MatchTrackingStateType>(initialState)

export const resetMatchTrackingState = () => {
  Object.keys(initialState).forEach((key) => {
    MatchTrackingState[key] = initialState[key]
  })
}
